var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnoScreenig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6646_5006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5862 37.7414L20 38.4311L12.4138 37.7414C14.4828 36.3621 14.4828 33.6035 14.4828 33.6035L20 32.9138L25.5173 33.6035C25.5173 33.6035 25.5173 36.3621 27.5862 37.7414Z",
    fill: "#3F5C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6551 39.1206C29.6528 39.8815 29.0366 40.4977 28.2758 40.5H11.724C10.9646 40.4943 10.3504 39.8801 10.3447 39.1206C10.347 38.3598 10.9632 37.7436 11.724 37.7413H28.2758C29.0352 37.747 29.6494 38.3612 29.6551 39.1206Z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 29.4655V32.2241C39.9977 32.9849 39.3815 33.6011 38.6207 33.6034H1.37931C0.618481 33.6011 0.00227228 32.9849 0 32.2241V29.4655H40Z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 6.70689V30.1552H0V6.70689C0.00227228 5.94606 0.618481 5.32985 1.37931 5.32758H38.6207C39.3815 5.32985 39.9977 5.94606 40 6.70689Z",
    fill: "#90BAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8828 5.35531C32.4069 5.576 0 7.81048 0 30.1553V6.70703C0.00227228 5.9462 0.618481 5.32999 1.37931 5.32772H38.6207C38.7088 5.32629 38.7968 5.33555 38.8828 5.35531Z",
    fill: "#B0D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 0.5L10.345 6.01724V16.3621L20.0001 21.8793L29.6553 16.3621V6.01724L20.0001 0.5Z",
    fill: "#FB7B76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6552 6.01721V16.362L20 21.8793V11.5345L29.6552 6.01721Z",
    fill: "#DF4D60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.5345V21.8793L10.345 16.362V6.01721L20.0001 11.5345Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5815 24.84L20.6898 25.7318V21.8794C20.6898 21.4985 20.381 21.1897 20.0001 21.1897C19.6193 21.1897 19.3105 21.4985 19.3105 21.8794V25.7318L18.4188 24.84C18.1482 24.5787 17.718 24.5824 17.452 24.8484C17.186 25.1145 17.1822 25.5446 17.4436 25.8152L19.5126 27.8842C19.7819 28.1534 20.2184 28.1534 20.4877 27.8842L22.5567 25.8152C22.8181 25.5446 22.8143 25.1145 22.5483 24.8484C22.2823 24.5824 21.8521 24.5787 21.5815 24.84Z",
    fill: "#2980BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.7648L6.66349 17.691L6.99039 16.4731C7.0542 16.2346 6.98593 15.9802 6.81129 15.8056C6.63664 15.6311 6.38216 15.563 6.1437 15.627C5.90524 15.691 5.71903 15.8774 5.65522 16.1159L4.8966 18.9434C4.8492 19.1201 4.87395 19.3084 4.96539 19.4669C5.05683 19.6253 5.20748 19.7409 5.38418 19.7883L8.21177 20.5469C8.27002 20.5626 8.33006 20.5707 8.39039 20.571C8.73759 20.5725 9.03175 20.3156 9.07708 19.9714C9.12241 19.6272 8.90476 19.3029 8.56901 19.2145L7.35108 18.8883L10.6897 16.9593C10.9048 16.837 11.0379 16.6088 11.0385 16.3613C11.039 16.1138 10.9069 15.885 10.6923 15.7618C10.4777 15.6385 10.2135 15.6397 10 15.7648Z",
    fill: "#2980BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0994 18.9421L34.3408 16.1145C34.2422 15.7466 33.8639 15.5283 33.496 15.6269C33.128 15.7256 32.9097 16.1038 33.0084 16.4717L33.3353 17.6897L30.0001 15.7648C29.7866 15.6397 29.5224 15.6385 29.3078 15.7618C29.0932 15.885 28.9611 16.1138 28.9617 16.3613C28.9622 16.6088 29.0953 16.837 29.3105 16.9593L32.6463 18.8855L31.4284 19.2117C31.0913 19.2991 30.8722 19.6241 30.9176 19.9693C30.9631 20.3146 31.2588 20.5718 31.607 20.569C31.6673 20.5687 31.7274 20.5606 31.7856 20.5448L34.6132 19.7862C34.9803 19.687 35.1978 19.3094 35.0994 18.9421Z",
    fill: "#2980BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6646_5006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnoScreenig);
export default __webpack_public_path__ + "static/media/ano-screenig.2197827fc052aa98261654400833bafd.svg";
export { ForwardRef as ReactComponent };